<template>
  <div class="page-root">
    <pageHeader></pageHeader>
    <div class="main">
      <div class="card">          
        <MeCard></MeCard>
      </div>
      <div class="content-section">
        <TechStackCard></TechStackCard>
        <ContactForm></ContactForm>
      </div>
    </div>
    <footer class="footer">
      <p>Made By @Saad</p>
    </footer>
  </div>
</template>

<script>
import MeCard from '../components/MeCard.vue';
import pageHeader from '../components/Header.vue';
import TechStackCard from '../pages/TechStack.vue';
import ContactForm from '../components/ContactForm.vue';
  
export default {
  name: 'TechStackPage',
  components: {
    pageHeader,
    MeCard,
    TechStackCard,
    ContactForm
  }
}
</script>

<style>
:root {
  --background-color: #0f0d0d; 
  --primary-color: #ffffff;
}

body {
  background-color: var(--background-color);
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

#app {
  background-color: var(--background-color);
  color: var(--text-color);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.main {
  display: flex;
  flex-direction: row;
  gap: 40px;
  background-color: var(--background-color);
  min-height: calc(100vh - 80px);
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  justify-content: center;
  align-items: flex-start;
}

.card {
  margin-top: 50px;
  background-color: var(--background-color);
  position: sticky;
  top: 70px;
  align-self: flex-start;
  z-index: 1000;
  flex-shrink: 0;
}

.content-section {
  flex: 1;
  max-width: 800px;
}

h1, h2, h3, p, span {
  color: var(--text-color);
}

.pageHeader, .MeCard, .ProfileSection, .ProjectCard, .TechStackCard, .ContactForm {
  background-color: var(--background-color);
}

.footer {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  background-color: #0f0d0d;
  color: #ffffff;
  font-weight: bold;
  font-size: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 90px;
}


@media screen and (max-width: 1024px) {
  .main{
      flex-direction: column;
      margin-left: 0;
      margin-right: 0;
      padding: 0 20px;
      align-items: center;
  }
  .card {
    position: static;
    top: auto;
    align-self: center;
    margin: 0 auto;
    padding: 0;
    z-index: auto;
    margin-top: 20px;
    width: 100%;
    max-width: 500px;
    display: flex;
    justify-content: center; 
    align-items: center;
  }
  .content-section {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (min-width: 1024px) {
  .main {
    padding: 0 40px;
  }
}
</style>
